import { createSelector } from '@reduxjs/toolkit'
import { CardScanState, CheckoutAppSelector, useAppSelector } from '../'
import { CheckPoint, ScanStatus } from '../../model'

/* Selectors */
export const cardScanSelector: CheckoutAppSelector<CardScanState> = (state) => state.cardScan

export const cardScanStatusSelector: CheckoutAppSelector<ScanStatus> = createSelector(cardScanSelector, (state) => state.status)

export const checkpointSelector: CheckoutAppSelector<CheckPoint> = createSelector(cardScanSelector, (state) => state.checkpoint)

/* React Hooks */
export const useCardScanStatus = (): ScanStatus => useAppSelector(cardScanStatusSelector)

export const useCheckpoint = (): CheckPoint => useAppSelector(checkpointSelector)

export const useIsReadyToScan = (): boolean => useAppSelector(cardScanStatusSelector) === ScanStatus.Ready
